import React from 'react';
import {motion} from 'framer-motion';
import {Link} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiArrowLeft}=FiIcons;

const ImprintPage=()=> {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-stone-100 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{opacity: 0,y: 30}}
          animate={{opacity: 1,y: 0}}
          transition={{duration: 0.8}}
        >
          <Link
            to="/"
            className="inline-flex items-center text-amber-700 hover:text-amber-800 mb-8 transition-colors"
          >
            <SafeIcon icon={FiArrowLeft} className="w-4 h-4 mr-2" />
            Zurück zur Startseite
          </Link>

          <div className="bg-gradient-to-r from-stone-50 to-slate-50 px-6 py-8 rounded-t-2xl border border-stone-200">
            <h1 className="text-4xl font-bold text-stone-800">Impressum</h1>
          </div>

          <div className="bg-white p-8 rounded-b-2xl shadow-lg border-l border-r border-b border-stone-200">
            <div className="prose prose-stone max-w-none space-y-8 text-stone-700">
              <div>
                <h2 className="text-xl font-semibold text-stone-800 mb-3">
                  Angaben gemäß § 5 DDG
                </h2>
                <p>
                  Nadine Rau u. Mike Trepte GbR
                  <br />
                  Bettenhäuserstr. 1
                  <br />
                  34123 Kassel
                  <br />
                  Deutschland
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-stone-800 mb-3">
                  Geschäftsführer
                </h2>
                <p>Nadine Rau, Mike Trepte</p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-stone-800 mb-3">
                  Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
                </h2>
                <p>
                  Nadine Rau
                  <br />
                  Bettenhäuserstr. 1
                  <br />
                  34123 Kassel
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-stone-800 mb-3">
                  Kontakt
                </h2>
                <p>
                  Telefon: 0561 / 43027276
                  <br />
                  E-Mail: nadine.rau@yin-und-klang.de
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-stone-800 mb-3">
                  Umsatzsteuer-ID
                </h2>
                <p>
                  Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
                  DE338605405
                </p>
              </div>

              <div className="pt-6 border-t border-stone-100">
                <h2 className="text-xl font-semibold text-stone-800 mb-3">
                  Bildnachweis
                </h2>
                <p>
                  Alle auf dieser Website verwendeten Fotografien wurden erstellt von
                  Mike Trepte bzw. sind lizenziert über Canva Pro (canva.com) und werden
                  im Rahmen der Canva Content License genutzt.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ImprintPage;